import { ChiptaElement, html } from 'chipta-libs/main.js';
import { basicIconStyle } from 'styles/basic-icon.js';

class IconCross extends basicIconStyle(ChiptaElement) {

  render() {
    return html`
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
      >
        <line x1='6' y1='6' x2='18' y2='18' />
        <line x1='6' y1='18' x2='18' y2='6' />
      </svg>
    `;
  }

}

customElements.define('icon-cross', IconCross);
